"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcDayStart = calcDayStart;
exports.calcDayEnd = calcDayEnd;
exports.calcStartDate = calcStartDate;
exports.calcEndDate = calcEndDate;
exports.makeTableDates = makeTableDates;
exports.makeTableDate = makeTableDate;
exports.endDateForPeriod = endDateForPeriod;
exports.truncate = truncate;
const luxon_1 = require("luxon");
const tableDate_1 = require("./tableDate");
const periodTypes_1 = __importDefault(require("./periodTypes"));
const viewTypes_1 = __importDefault(require("./viewTypes"));
function calcDayStart(date, start, localTimeZone, timeZone) {
    let d = luxon_1.DateTime.fromISO(date.toISOString(), { zone: localTimeZone });
    if (!d.isValid) {
        throw new Error('invalid date');
    }
    if (start) {
        let hours = start;
        if (timeZone && localTimeZone != timeZone) {
            let m = luxon_1.DateTime.fromISO(d.toISO(), { zone: timeZone });
            if (!m.isValid) {
                throw new Error('invalid date');
            }
            m = m.set({ hour: hours });
            hours = m.setZone(localTimeZone).hour;
        }
        d = d.set({ hour: hours });
    }
    else {
        d = d.set({ hour: 0 });
    }
    return d.toJSDate();
}
function calcDayEnd(date, end, localTimeZone, timeZone) {
    let d = luxon_1.DateTime.fromISO(date.toISOString(), { zone: localTimeZone });
    if (!d.isValid) {
        throw new Error('invalid date');
    }
    if (end) {
        let hours = end;
        if (timeZone && localTimeZone != timeZone) {
            d = luxon_1.DateTime.fromISO(d.toISO(), { zone: timeZone });
            if (!d.isValid) {
                throw new Error('invalid date');
            }
            d = d.set({ hour: hours });
        }
        d = d.set({ hour: hours });
    }
    else {
        d = d.set({ hour: 24 });
    }
    return d.toJSDate();
}
function calcStartDate(truncatedDate, viewType, localTimeZone, options) {
    let date = luxon_1.DateTime.fromJSDate(truncatedDate, { zone: localTimeZone });
    if (!date.isValid) {
        throw new Error('invalid date');
    }
    switch (viewType) {
        case viewTypes_1.default.MONTH:
            if (options?.monthStart && date.day < options.monthStart) {
                date = date.plus({ month: -1 });
            }
            date = date.set({ day: 1 });
            if (options?.monthStart) {
                date = date.set({ day: options.monthStart });
            }
            break;
        case viewTypes_1.default.WEEK:
            // go BACK to previous sunday or the branch setting day
            const dayOfWeek = date.weekday;
            let start = 0; // Sunday
            if (options?.weekStart) {
                start = options.weekStart;
            }
            const offset = ((dayOfWeek - start) + 7) % 7;
            date = date.set({ day: date.day - offset });
            break;
        case viewTypes_1.default.DAY:
            const d = calcDayStart(date.toJSDate(), options?.dayStart || 0, localTimeZone, options?.branchTimeZone);
            date = luxon_1.DateTime.fromJSDate(d, { zone: localTimeZone });
            break;
        default:
            throw new Error("開始日と終了日を選択してください。");
    }
    return date.toJSDate();
}
function calcEndDate(startDate, viewType, localTimeZone, options) {
    let endDate = luxon_1.DateTime.fromJSDate(startDate, { zone: localTimeZone });
    switch (viewType) {
        case viewTypes_1.default.MONTH:
            endDate = endDate.set({ month: endDate.month + 1 });
            endDate = endDate.set({ day: 1 });
            if (options?.monthStart) {
                endDate = endDate.set({ day: options.monthStart });
            }
            break;
        case viewTypes_1.default.WEEK:
            endDate = endDate.set({ day: endDate.day + 7 });
            break;
        case viewTypes_1.default.DAY:
            endDate = luxon_1.DateTime.fromJSDate(calcDayEnd(startDate, options?.dayEnd || 24, localTimeZone, options?.branchTimeZone));
            break;
        default:
            throw new Error("開始日と終了日を選択してください。");
    }
    return endDate.toJSDate();
}
function makeTableDates(startDate, endDate, period, localTimeZone) {
    let dates = [];
    switch (period) {
        case periodTypes_1.default.HOUR:
            dates = makeTableDatesHour(startDate, endDate, localTimeZone);
            break;
        case periodTypes_1.default.DAY:
            dates = makeTableDatesDay(startDate, endDate, localTimeZone);
            break;
        default:
            throw new Error("unimplemented");
    }
    return dates;
}
function makeTableDatesHour(startDate, endDate, localTimeZone) {
    const dates = [];
    let s = luxon_1.DateTime.fromJSDate(startDate, { zone: localTimeZone });
    while (s.valueOf() < endDate.valueOf()) {
        const d = makeTableDate(s.toJSDate(), periodTypes_1.default.HOUR, localTimeZone);
        dates.push(d);
        s = s.plus({ hours: 1 });
    }
    return dates;
}
function makeTableDatesDay(startDate, endDate, localTimeZone) {
    let s = luxon_1.DateTime.fromJSDate(startDate, { zone: localTimeZone });
    const dates = [];
    while (s.valueOf() < endDate.valueOf()) {
        const d = makeTableDate(s.toJSDate(), periodTypes_1.default.DAY, localTimeZone);
        dates.push(d);
        s = s.plus({ days: 1 });
    }
    return dates;
}
function makeTableDate(startDate, period, localTimeZone) {
    const s = new Date(startDate);
    const t = new tableDate_1.TableDate(s, endDateForPeriod(s, period, localTimeZone));
    return t;
}
function endDateForPeriod(startDate, period, localTimeZone) {
    let end = luxon_1.DateTime.fromJSDate(startDate, { zone: localTimeZone });
    switch (period) {
        case periodTypes_1.default.HOUR:
            end = end.plus({ hours: 1 });
            break;
        case periodTypes_1.default.DAY:
            end = end.plus({ days: 1 });
            break;
        default:
            throw new Error("unimplemented period type");
    }
    end = end.plus({ milliseconds: -1 });
    return end.toJSDate();
}
function truncate(date, period, timeZone) {
    let d = luxon_1.DateTime.fromJSDate(date, { zone: timeZone });
    switch (period) {
        case periodTypes_1.default.HOUR:
            d = d.startOf('hour');
            break;
        case periodTypes_1.default.DAY:
            d = d.startOf('day');
            break;
        default:
            throw new Error("unimplemented period type");
    }
    return d.toJSDate();
}
